const isInfowindowOpen = (categoryMap) => {
  const exists = categoryMap.getElementsByClassName('wpgmza-open');
  if (exists !== [] && exists.length !== 0) {
    return true;
  }
  return false;
};

document.addEventListener('click', () => {
  const categoryWindow = document.querySelectorAll('.wpgmza-marker-listing-category-filter');

  if (categoryWindow.length === 0) {
    return;
  }

  Array.from(categoryWindow).forEach((elem) => {
    const mapId = elem.getAttribute('data-map-id');
    const categoryMap = document.getElementById(`wpgmza_map_${mapId}`);

    if (isInfowindowOpen(categoryMap)) {
      elem.setAttribute('style', 'z-index: 9');
    } else {
      elem.setAttribute('style', 'z-index: 15');
    }

    const checkboxes = categoryMap.getElementsByClassName('wpgmza_checkbox');

    Array.from(checkboxes).forEach((checkbox) => {
      if (checkbox.checked) {
        checkbox.parentElement.classList.add('cat-checkbox--active');
      } else if (checkbox.parentElement.classList.contains('cat-checkbox--active')) {
        checkbox.parentElement.classList.remove('cat-checkbox--active');
      }
    });
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const categoryWindow = document.querySelectorAll('.wpgmza-marker-listing-category-filter');

  if (categoryWindow.length === 0) {
    return;
  }

  Array.from(categoryWindow).forEach((elem) => {
    const mapId = elem.getAttribute('data-map-id');
    const categoryMap = document.getElementById(`wpgmza_map_${mapId}`);

    // Exit if no map related to the category filter.
    if (!categoryMap) {
      return;
    }

    // Setup interval to check if map is initialized before appending the filter otherwise.
    /* eslint-disable prefer-const */
    let initCheck;
    initCheck = setInterval(() => {
      if (categoryMap.classList.contains('wpgmza-initialized')) {
        clearTimeout(initCheck);
        categoryMap.appendChild(elem);
      }
    }, 100);
    /* eslint-enable prefer-const */
  });
});
